import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const SetCurrentTargetEvent = new ReduxAsyncAction<'SET_CURRENT_TARGET_EVENT', string, string>('SET_CURRENT_TARGET_EVENT');

SetCurrentTargetEvent.registerRequest(async (targetEvent: string) => {
  return targetEvent;
});

export const SET_CURRENT_TARGET_EVENT = SetCurrentTargetEvent.actionNamespaceConstants;

export const setCurrentTargetEvent = SetCurrentTargetEvent.request;

export type SetCurrentTargetEventResponseAction = Action<typeof SET_CURRENT_TARGET_EVENT.response> & { data: string };
